import reducer from "./reducers";

export { default as coreOperations } from "./operations";
export { default as coreSelectors } from "./selectors";
export { default as coreTypes } from "./types";

export default reducer;
